var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"main-loader"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-cnt"},[_c('img',{attrs:{"src":require("@/assets/main_logo.svg"),"width":"200","alt":"PayAngel"}}),_c('p',{staticClass:"mb-0"},[_vm._v("Please wait...")])])
}]

export { render, staticRenderFns }